module.exports = __webpack_public_path__ + "img/salt_spray_tester.11b60303.jpg";